import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import EmployerSuggest from '@Components/SuggestSearch/EmployerSuggest';
import { getInputErrorsObject } from '@Utils/helpers';

function SearchEmployer({
  name,
  labelName,
  labelCol,
  labelClassName,
  errors,
  setValue,
  style,
  defaultValue,
  allowAll,
}) {
  const [errorDetail, setErrorDetail] = useState();
  const [selected, setSelected] = useState();

  useEffect(() => {
    if (name && errors) {
      setErrorDetail(getInputErrorsObject(name, errors));
    }
  }, [name, errors && Object.keys(errors)]);

  useEffect(() => {
    if (selected) {
      setValue(name, selected);
    } else {
      setValue(name, '');
    }
  }, [selected]);

  return (
    <EmployerSuggest
      allowAll={allowAll}
      style={style}
      name={name}
      labelName={labelName}
      labelCol={labelCol}
      labelClassName={labelClassName}
      selected={selected}
      setSelected={setSelected}
      errorDetail={errorDetail}
      defaultValue={defaultValue}
    />
  );
}

SearchEmployer.propTypes = {
  name: PropTypes.string,
  labelName: PropTypes.string,
  labelClassName: PropTypes.string,
  labelCol: PropTypes.string,
  register: PropTypes.object,
  errors: PropTypes.object,
  style: PropTypes.object,
  setValue: PropTypes.func,
  allowAll: PropTypes.bool,
  defaultValue: PropTypes.any,
};

export default SearchEmployer;
